import { Injectable } from '@angular/core';
import {
  WebSocketSubject,
  WebSocketSubjectConfig,
  webSocket,
} from 'rxjs/webSocket';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  webSocket<T>(
    urlConfigOrSource: string | WebSocketSubjectConfig<T>,
  ): WebSocketSubject<T> {
    return webSocket<T>(urlConfigOrSource);
  }
}
